import { CheckCircle2 } from "lucide-react";

const ABOUT_IMG =
    "https://images.unsplash.com/photo-1758630737361-ca7532fb5e7f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBvZmZpY2UlMjBzdXBwbGllcyUyMHN0YXRpb25lcnklMjBkZXNrfGVufDB8fHx8MTc3NzY3NDkzOXww&ixlib=rb-4.1.0&q=85";

const highlights = [
    "Variedad y precios competitivos",
    "De papelería tradicional a distribuidora mayorista",
    "Compromiso con la satisfacción del cliente",
];

export default function About() {
    return (
        <section
            id="nosotros"
            data-testid="about-section"
            className="py-20 lg:py-32 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
                    <div className="lg:col-span-5 fade-up order-2 lg:order-1">
                        <div className="relative">
                            <div className="rounded-[2rem] overflow-hidden shadow-xl">
                                <img
                                    src={ABOUT_IMG}
                                    alt="Nuestra historia"
                                    className="w-full h-[520px] object-cover"
                                    data-testid="about-image"
                                />
                            </div>
                            {/* Decorative big pill */}
                            <div className="absolute -bottom-6 -right-6 bg-[#f4861c] text-white rounded-3xl px-6 py-5 shadow-xl max-w-[220px]">
                                <div className="font-display font-black text-3xl leading-none">
                                    +
                                </div>
                                <div className="text-xs uppercase tracking-widest font-semibold mt-1">
                                    Variedad
                                </div>
                                <div className="text-[11px] opacity-90 mt-1">
                                    Precios competitivos
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-7 fade-up order-1 lg:order-2">
                        <span className="opteris-chip">
                            Nuestra Historia
                        </span>
                        <h2
                            data-testid="about-heading"
                            className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-5 leading-[1.1]"
                        >
                            Una trayectoria construida con{" "}
                            <span className="text-[#ea4d87]">
                                compromiso
                            </span>{" "}
                            y visión.
                        </h2>

                        <p
                            data-testid="about-paragraph-1"
                            className="mt-6 text-gray-600 leading-relaxed"
                        >
                            Nuestra trayectoria comenzó con la visión de
                            simplificar el abastecimiento de materiales
                            esenciales para la comunidad local, identificando la
                            necesidad de un proveedor que combinara variedad y
                            precios competitivos.
                        </p>
                        <p
                            data-testid="about-paragraph-2"
                            className="mt-4 text-gray-600 leading-relaxed"
                        >
                            Conforme pasa el tiempo, evolucionamos de una
                            papelería tradicional a una distribuidora mayorista
                            capaz de surtir a grandes corporativos y centros
                            educativos. Esta transformación ha sido impulsada
                            por nuestra constante adaptación a las tendencias
                            de oficina y un compromiso inquebrantable con la
                            satisfacción de quienes confían en nosotros.
                        </p>

                        <ul className="mt-8 space-y-3">
                            {highlights.map((h, i) => (
                                <li
                                    key={i}
                                    data-testid={`about-highlight-${i}`}
                                    className="flex items-start gap-3"
                                >
                                    <CheckCircle2
                                        size={22}
                                        className="text-[#f4861c] flex-shrink-0 mt-0.5"
                                    />
                                    <span className="text-gray-800 font-medium">
                                        {h}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
}
